import "./GallerySection.css";

import DefaultSwiper from "./DefaultSwiper";

export const GallerySection = () => {
  return (
    <section className="gallery-section">
      <div className="gallery-content">
        <p className="gallery-title">Galería</p>

        <DefaultSwiper />
      </div>
    </section>
  );
};
